import { socialLinks } from "@/data/sampleData";
import { Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden"
      style={{
        background: "hsl(var(--footer-bg))",
        color: "hsl(var(--footer-fg))",
      }}
    >
      {/* Faded group photo background */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/images/events/spring-team-photo-sm.webp"
          alt=""
          className="w-full h-full object-cover opacity-[0.06]"
        />
      </div>

      <div className="relative container mx-auto px-5 md:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="space-y-3">
            <h3
              className="text-lg font-black"
              style={{ color: "hsl(var(--footer-fg))" }}
            >
              Quizrun
            </h3>
            <p className="text-sm leading-relaxed" style={{ opacity: 0.7 }}>
              A running event where your brain earns you a head start. Running
              meets knowledge — in parks around the world.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h4
              className="text-xs font-bold uppercase tracking-widest"
              style={{ opacity: 0.6 }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { to: "/#how-it-works", label: "How It Works", isHash: true },
                { to: "/events", label: "Events & Results" },
                { to: "/geography", label: "Geography" },
                { to: "/partnership", label: "Partner With Us" },
                { to: "/about", label: "About" },
                { to: "/terms", label: "Terms & Waiver" },
                { to: "/privacy", label: "Privacy Policy" },
                { to: "/credits", label: "Credits" },
                { to: "/support", label: "Support Quizrun", emoji: "❤️" },
              ].map((link) => (
                <li key={link.to}>
                  {link.isHash ? (
                    <a
                      href={link.to}
                      className="text-sm transition-opacity hover:opacity-100"
                      style={{ opacity: 0.7 }}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.to}
                      className="text-sm transition-opacity hover:opacity-100"
                      style={{ opacity: 0.7 }}
                    >
                      {link.label}{'emoji' in link && <> <span aria-hidden="true">{link.emoji}</span></>}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div className="space-y-3">
            <h4
              className="text-xs font-bold uppercase tracking-widest"
              style={{ opacity: 0.6 }}
            >
              Connect
            </h4>
            <div className="flex gap-2">
              <a
                href={socialLinks.strava}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Strava"
                className="w-9 h-9 rounded-lg border flex items-center justify-center transition-opacity hover:opacity-100"
                style={{
                  opacity: 0.7,
                  borderColor: "hsl(var(--footer-fg) / 0.15)",
                }}
              >
                <svg
                  className="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
                </svg>
              </a>
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 rounded-lg border flex items-center justify-center transition-opacity hover:opacity-100"
                style={{
                  opacity: 0.7,
                  borderColor: "hsl(var(--footer-fg) / 0.15)",
                }}
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-lg border flex items-center justify-center transition-opacity hover:opacity-100"
                style={{
                  opacity: 0.7,
                  borderColor: "hsl(var(--footer-fg) / 0.15)",
                }}
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={socialLinks.telegram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
                className="w-9 h-9 rounded-lg border flex items-center justify-center transition-opacity hover:opacity-100"
                style={{
                  opacity: 0.7,
                  borderColor: "hsl(var(--footer-fg) / 0.15)",
                }}
              >
                <svg
                  className="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div
          className="pt-6 text-center"
          style={{ borderTop: "1px solid hsl(var(--footer-fg) / 0.1)" }}
        >
          <p className="text-xs" style={{ opacity: 0.5 }}>
            &copy; 2025–{new Date().getFullYear()} Quizrun. Made with{" "}
            <span aria-hidden="true" style={{ display: "inline-block", transform: "scaleX(-1)" }}>
              🏃
            </span>{" "}
            and <span aria-hidden="true">🧠</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
